import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Snackbar, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import Bandeira from './Bandeira';
import { atualizarMeuIdioma } from '../../api/usuarios';

// `value` é o formato esperado pelo backend (ex.: "pt-BR").
const IDIOMAS = {
  pt: { name: 'Português', value: 'pt-BR' },
  en: { name: 'English', value: 'en-US' },
  es: { name: 'Español', value: 'es-ES' },
};

export default function LanguageMenu() {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [erroIdioma, setErroIdioma] = useState(false);

  const atual = i18n.language?.split('-')[0];
  const selecionado = IDIOMAS[atual] ?? IDIOMAS.pt;

  const handleTrocar = (idioma) => {
    // Troca otimista; persiste no backend em background.
    window.localStorage.setItem('konq.idioma', idioma);
    i18n.changeLanguage(idioma);
    setAnchorEl(null);
    atualizarMeuIdioma(IDIOMAS[idioma]?.value ?? idioma).catch(() => setErroIdioma(true));
  };

  return (
    <>
      <Tooltip title={t('Languages')}>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} aria-haspopup="true">
          <Bandeira idioma={IDIOMAS[atual] ? atual : 'pt'} titulo={selecionado.name} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{ sx: { minWidth: 180, mt: 1 } }}
      >
        {Object.entries(IDIOMAS).map(([codigo, idioma]) => (
          <MenuItem key={codigo} selected={codigo === atual} onClick={() => handleTrocar(codigo)}>
            <ListItemIcon>
              <Bandeira idioma={codigo} titulo={idioma.name} size={20} />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ fontSize: 14 }}>{idioma.name}</ListItemText>
            {codigo === atual && <CheckIcon fontSize="small" color="primary" sx={{ ml: 1 }} />}
          </MenuItem>
        ))}
      </Menu>
      <Snackbar
        open={erroIdioma}
        autoHideDuration={4000}
        onClose={() => setErroIdioma(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="warning" onClose={() => setErroIdioma(false)} sx={{ width: '100%' }}>
          {t('Language preference not saved. Please try again.')}
        </Alert>
      </Snackbar>
    </>
  );
}
